import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Typography, CircularProgress, Alert, Button } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import FormsLayout from '../layout/FormsLayout';
import { confirmRegistrationEmail } from '../api/auth-api';
import { loginPage } from '../store/fixed-routing';

const SUCCESS_MESSAGE = 'Dziękujemy za potwierdzenie adresu email — można się już zalogować do systemu';
const REDIRECT_SECONDS = 5;

const ConfirmAccountPage = () => {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const key = searchParams.get('key');
	const login = searchParams.get('login');
	const [loading, setLoading] = useState(true);
	const [success, setSuccess] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const [secondsLeft, setSecondsLeft] = useState(REDIRECT_SECONDS);

	useEffect(() => {
		let cancelled = false;
		setLoading(true);
		setSuccess(false);
		setError(null);

		if (!key || !login) {
			setError('Nieprawidłowy link potwierdzający.');
			setLoading(false);
			return () => {
				cancelled = true;
			};
		}

		confirmRegistrationEmail(key, login)
			.then((res) => {
				if (cancelled) {
					return;
				}
				if (res?.message) {
					setSuccess(true);
					setError(null);
				} else {
					setSuccess(false);
					setError('Nie udało się potwierdzić adresu email.');
				}
			})
			.catch(() => {
				if (cancelled) {
					return;
				}
				setSuccess(false);
				setError('Nie udało się potwierdzić adresu email.');
			})
			.finally(() => {
				if (!cancelled) {
					setLoading(false);
				}
			});

		return () => {
			cancelled = true;
		};
	}, [key, login]);

	useEffect(() => {
		if (!success) {
			return undefined;
		}

		setSecondsLeft(REDIRECT_SECONDS);
		const redirectTimer = window.setTimeout(() => {
			navigate(loginPage);
		}, REDIRECT_SECONDS * 1000);
		const countdownTimer = window.setInterval(() => {
			setSecondsLeft((prev) => (prev > 0 ? prev - 1 : 0));
		}, 1000);

		return () => {
			window.clearTimeout(redirectTimer);
			window.clearInterval(countdownTimer);
		};
	}, [success, navigate]);

	return (
		<FormsLayout>
			<Card sx={{ maxWidth: 480, width: '100%', mx: 'auto' }}>
				<CardContent>
					<Typography
						variant='h5'
						gutterBottom
					>
						Potwierdzenie adresu email
					</Typography>
					{loading && (
						<Box
							display='flex'
							justifyContent='center'
							py={4}
						>
							<CircularProgress />
						</Box>
					)}
					{!loading && success && (
						<>
							<Alert
								severity='success'
								sx={{ mb: 2 }}
							>
								{SUCCESS_MESSAGE}
							</Alert>
							<Button
								variant='contained'
								onClick={() => navigate(loginPage)}
							>
								Przejdź do logowania
							</Button>
							<Typography
								variant='body2'
								color='text.secondary'
								sx={{ mt: 2 }}
							>
								Automatyczne przekierowanie za {secondsLeft} s…
							</Typography>
						</>
					)}
					{!loading && !success && error && <Alert severity='error'>{error}</Alert>}
				</CardContent>
			</Card>
		</FormsLayout>
	);
};

export default ConfirmAccountPage;
